import { render, staticRenderFns } from "./act-popbox.vue?vue&type=template&id=76a5b656&comments=true&"
import script from "./act-popbox.vue?vue&type=script&lang=js&"
export * from "./act-popbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports